import React, { memo } from 'react';
import PropTypes from 'prop-types';

const StaffMobileColumn = ( { row } ) => {
	return (
		<div style={{
			whiteSpace: 'nowrap',
			overflow: 'hidden',
			textOverflow: 'ellipsis'
		}}>
			<span><strong>{ `${ row.lastName }, ${ row.firstName }` }</strong></span>
			<br />
			{
				row.title
					? <>
						<span>{ row.title }</span>
						<br />
					</>
					: null
			}
			<span>{ row.email }</span>
		</div>
	);
};

StaffMobileColumn.propTypes = { row: PropTypes.object.isRequired };

export default memo( StaffMobileColumn );
